import LogoSpinner from "components/Spinner/LogoSpinner";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "store/reducers/authReducer";
import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";

export default function Logout() {
  const dispatch = useDispatch();
  const navigate = useViewTransitionNavigate();

  useEffect(() => {
    // تقليل الوقت قليلاً لسرعة تجربة المستخدم، 2000ms كافية جداً
    const time = setTimeout(() => {
      dispatch(logout());
      navigate("/", { replace: true });
    }, 2000);

    return () => clearTimeout(time);
  }, [dispatch, navigate]);

  return <LogoSpinner message="جاري تسجيل الخروج.. ننتظر عودتك قريباً" />;
}
